import React from 'react';
import logocolor from './shantal-colores.png';
import load from './partials/load.svg';
import { ToastContainer, toast } from 'react-toastify';
class Login	extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			username : '',
			password : '',
			load : '',
		};
		this.login = this.login.bind(this);
		this.inputHandler = this.inputHandler.bind(this);
	}
	componentDidMount(){
		this.setState({load: false});
	}
	login(e){
		this.setState({load: ! this.state.load});
		e.preventDefault();
		fetch(window.$api+'/login',{
			method : 'POST',
			headers : {	'Content-Type': 'application/json' },
			body : JSON.stringify({ 
				username : this.state.username,
				password : this.state.password
			})
		})
		.then(res=>res.json()).then(
			user=>{
				this.setState({load: ! this.state.load});
				if( user.status === "success"  ){
					localStorage.setItem('sesion',JSON.stringify(user));
					this.props.history.push('/dashboard');
				}else{
					if( user.status === 'fail'){
						toast.warning(user.message);
					}else{
						toast.warning(user.message);
					}
				}
			},
			error=>{
				
				this.setState({load: ! this.state.load});
				toast.error('Hubo un error, intente mas tarde');
			}
		);
	}
	inputHandler(e){
		let input = e.target;
		this.setState({ [input.name] : input.value });
	}
	render(){
		return(
			<div className="wrap-login">
				<div className="row">
					<div className="xs-12 sm-8 md-6 lg-5 child-center">
						<form onSubmit={this.login} className="login">
							<h1>¡Bienvenido!</h1>
							<p>Inicie sesión para poder continuar</p>
							<div className="field">
								<input type="text" name="username" onChange={this.inputHandler} value={this.state.username} placeholder=" "/>
								<span>Usuario</span><i className="icon-user-login"></i>
							</div>
							<div className="field">
								<input type="password" name="password" onChange={this.inputHandler} value={this.state.password} placeholder=" "/>
								<span>Contraseña</span><i className="icon-lock"></i>
							</div>
							<div className="text-center">
								<button className="btn btn-green-2">Iniciar</button>
							</div>
						</form>
					</div>
				</div>
				<div className={this.state.load?'load show':'load'}>
					<img src={load} alt='load'/>
				</div>
				<img src={logocolor} className="logocolor" alt="Logo"/>
				<ToastContainer
					position="top-center"
					autoClose={3000}
					hideProgressBar
					newestOnTop
					closeOnClick
					rtl={false}
					draggable={false}
					pauseOnHover
					/>
			</div>
		)
	}
}
export default Login;